/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Additional classification of a standalone portfolio, e.g. the selected SLB classification.
 * @export
 */
export const PortfolioAdditionalClassification = {
    Custody: 'CUSTODY',
    Collateral: 'COLLATERAL',
    Repo: 'REPO',
    Slb: 'SLB',
    SlbAndRepo: 'SLB_AND_REPO',
    Wash: 'WASH'
} as const;
export type PortfolioAdditionalClassification = typeof PortfolioAdditionalClassification[keyof typeof PortfolioAdditionalClassification];


export function instanceOfPortfolioAdditionalClassification(value: any): boolean {
    for (const key in PortfolioAdditionalClassification) {
        if (Object.prototype.hasOwnProperty.call(PortfolioAdditionalClassification, key)) {
            if (PortfolioAdditionalClassification[key as keyof typeof PortfolioAdditionalClassification] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioAdditionalClassificationFromJSON(json: any): PortfolioAdditionalClassification {
    return PortfolioAdditionalClassificationFromJSONTyped(json, false);
}

export function PortfolioAdditionalClassificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioAdditionalClassification {
    return json as PortfolioAdditionalClassification;
}

export function PortfolioAdditionalClassificationToJSON(value?: PortfolioAdditionalClassification | null): any {
    return value as any;
}

export function PortfolioAdditionalClassificationToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioAdditionalClassification {
    return value as PortfolioAdditionalClassification;
}

